import { render, staticRenderFns } from "./LaborProtectionChecklistsList.vue?vue&type=template&id=1d05f230&"
import script from "./LaborProtectionChecklistsList.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionChecklistsList.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionChecklistsList.vue?vue&type=style&index=0&id=1d05f230&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports